module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
    var listService = require('ListService.js'); 
    var constants = require('Constants.js');

    ; __append("\r\n<div class=\"row search-filters\" style=\"padding: 5px 15px;\">\r\n    <div class=\"search-wrapper\">\r\n        ")
    ;  if(listService.activeDashboardTab === constants.DASHBOARD_SECTION_APPS){ 
    ; __append("\r\n        <input type=\"text\" placeholder=\"Search by App Name \" class=\"workspace-filter search-app\" data-filter=\"-clear\" id=\"name-search\">\r\n        ")
    ;  } else{ 
    ; __append("\r\n            <input type=\"text\" placeholder=\"Search by Report Name \" class=\"workspace-filter search-app\" data-filter=\"-clear\" id=\"name-search\">\r\n        ")
    ;  } 
    ; __append("\r\n        <div class=\"icon-right clear-search\" title=\"Clear search\" style=\"display: none;\">x</div>\r\n    </div>\r\n\r\n    <div class=\"search-wrapper\">\r\n        <input type=\"text\" readonly value=\"Update Date\" data-default=\"Update Date\" data-filter=\"-clear\" class=\"workspace-filter filter-date-app date-filter\" id=\"date-filter\">\r\n        <img src=\"")
    ; __append( require('common/icons/caret-down.svg'))
    ; __append("\" class=\"icon-right caret-down date-filter\" />\r\n        \r\n        <div class=\"context-menu\" id=\"date-context-menu\" style=\"display: none;\">\r\n            <i class=\"filter-arrow up\"></i>\r\n            <div class=\"filter-button\" data-filterVal=\"7-days\">Last Week</div>\r\n            <div class=\"filter-button\" data-filterVal=\"30-days\">Last 30 Days</div>\r\n            <div class=\"filter-button\" data-filterVal=\"3-months\">Last 3 Months</div>\r\n            <div class=\"filter-button\" data-filterVal=\"6-months\">Last 6 Months</div>\r\n            <div class=\"filter-button\" data-filterVal=\"12-months\">Last Year</div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"search-wrapper\">\r\n        <input type=\"text\" readonly value=\"Status\" data-default=\"Status\" data-filter=\"-clear\" class=\"workspace-filter filter-status-app status-filter\" id=\"status-filter\">\r\n        <img src=\"")
    ; __append( require('common/icons/caret-down.svg'))
    ; __append("\" class=\"icon-right caret-down status-filter\" />\r\n\r\n        <div class=\"context-menu\" id=\"status-context-menu\" style=\"display: none;\">\r\n            <i class=\"filter-arrow up\"></i>\r\n            <div class=\"filter-button\" data-filterVal=\"published\">Published</div>\r\n            <div class=\"filter-button\" data-filterVal=\"draft\">Draft</div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}